// Download Scout (#2679, #2710): the version of the extension this deploy serves, and the zip itself. Both need the signed-in session; no token or secret is in the zip.
import { useEffect, useState } from 'react';
import { supabase } from './supabase';

async function authed(path) {
  const { data: { session } } = await supabase.auth.getSession();
  return fetch(path, { headers: { Authorization: `Bearer ${session?.access_token || ''}` } });
}

let cachedVersion = null;

export async function fetchScoutVersion() {
  if (cachedVersion) return cachedVersion;
  try {
    const res = await authed('/api/scout-extension?info=1');
    const d = await res.json();
    if (d && d.version) cachedVersion = d.version;
  } catch (_) { /* the label just stays without a number */ }
  return cachedVersion;
}

// Returns { ok: true } or { ok: false, error } with a plain message.
export async function downloadScout(version) {
  try {
    const res = await authed('/api/scout-extension');
    if (!res.ok) return { ok: false, error: res.status === 401 ? 'Sign in again, then try the download.' : 'Could not build the download. Try again in a minute.' };
    const blob = await res.blob();
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `scout-extension-${version || cachedVersion || 'latest'}.zip`;
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(url);
    return { ok: true };
  } catch (_) {
    return { ok: false, error: 'Could not reach CHARLIE for the download. Try again.' };
  }
}

export function useScoutVersion() {
  const [version, setVersion] = useState(cachedVersion || '');
  useEffect(() => {
    let live = true;
    fetchScoutVersion().then((v) => { if (live && v) setVersion(v); });
    return () => { live = false; };
  }, []);
  return version;
}
